<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.endpoints' | translate}}"
  [hidePagination]="true"
  [itemsData]="displayedEndpoints"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'endpoints'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

     Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        packageName
      </th>
      <th>
        resourceName
      </th>
      <th>
        methodName
      </th>
      <th>
        endpointCalls
      </th>
      <th>
        minExecutionTime
      </th>
      <th>
        avgExecutionTime
      </th>
      <th>
        maxExecutionTime
      </th>
      <th>
        firstStarted
      </th>
      <th>
        firstFinished
      </th>
      <th>
        lastStarted
      </th>
      <th>
        lastFinished
      </th>
    </tr>
  </ng-template>

  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-endpoint>

    <tr>
      <td>
        {{ endpoint?.resourceDescriptor?.packageName }}
      </td>
      <td>
        {{ endpoint?.resourceDescriptor?.resourceName }}
      </td>
      <td>
        {{ endpoint?.resourceDescriptor?.methodName }}
      </td>
      <td>
        {{ endpoint.endpointCalls }}
      </td>
      <td>
        {{ endpoint.minExecutionTime }}
      </td>
      <td>
        {{ endpoint.avgExecutionTime }}
      </td>
      <td>
        {{ endpoint.maxExecutionTime }}
      </td>
      <td>
        {{ endpoint.firstStarted?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td>
        {{ endpoint.firstFinished?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td>
        {{ endpoint.lastStarted?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
      <td>
        {{ endpoint.lastFinished?.toString() | date: 'dd.MM.yy HH:mm' }}
      </td>
    </tr>
  </ng-template>

  <!------------------------------

  Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
